<style lang="scss" scoped>
@mixin input-border {
    width:100%;
    margin: 0;
    height: 36px;
    line-height: 36px;
    position: relative;
    cursor: pointer;
}
@mixin btn-after($txt){
    content:$txt;
    position:absolute;
    left:-10px;
    top:-34px;
    width: 48px;
    height: 24px;
    background: #222C37;
    text-align:center;
    font-size:14px;
    color:#fff;
    line-height:24px;
}
.home{
    background:#fff;
    ::v-deep .el-button:active{
        border-color: #008A71;
        background-color: #008A71;
    }
    ::v-deep .el-button:focus-visible{
        outline: none;
    }
    .disabled{
        opacity:0.4;
        cursor:not-allowed;
    }
    .main{
        padding: 70px 0 0 0;
        width: 100%;
    }
    .subTitle{
        width: 100%;
        height: 107px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        font-size: 24px;
        font-weight: 600;
        color: #222C37;
        line-height: 24px;
    }
}
.column{
    width:100%;
    padding:40px 60px;
    box-sizing:border-box;
    border-top:1px solid #F2F3F3;
    &:last-child{
        border-bottom:1px solid #F2F3F3;
    }
    .column_fix{
        min-width:904px;
        max-width:1240px;
        margin:0 auto;
        display:flex;
        justify-content: space-between;
        .left{
            width:36%;
            margin-right:60px;
            strong{
                font-size:20px;
                padding-bottom:20px;
                display:block;
                span{
                    color:#FF4A4A;
                }
            }
            p{
                font-size:14px;
                color:#7A8087;
                line-height:1.5;
                a{
                    outline: none;
                    color: #425eb2;
                    text-decoration: underline;
                }
            }
            p.bottom{
                padding: 10px 0 0 0;
            }
            strong{
                padding: 0 0 15px 0;
            }
        }
        .right{
            width:calc(64% - 60px);
            .cover_fix{
                display: flex;
                align-items: center;
                justify-content: space-between;
                >div{
                    cursor: pointer;
                    width: calc(50% - 10px);
                    padding-bottom: calc(50% - 10px);
                    height: 0;
                    border: 1px solid #dee0e1;
                    position: relative;
                    .cover_txt{
                        position: absolute;
                        width: 100%;
                        top: 50%;
                        left: 50%;
                        padding-bottom: 100%;
                        background: #f8f8f9;
                        transform: translate(-50%,-50%);
                        &.recommend {
                            padding-bottom: 42.74%;
                        }
                        .bg{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            img{
                                width:100%;
                                height:auto;
                            }
                        }
                        .upTips{
                            position:absolute;
                            width:100%;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%,-50%);
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .logo{
                                width: 50px;
                                height: 50px;
                                border-radius:50%;
                                background: #FFFFFF;
                                border: 1px solid #DEE0E1;
                                font-size:16px;
                                color:#7A8087;
                                line-height:50px;
                                text-align:center;
                            }
                            p{
                                padding-top:10px;
                                font-size:16px;
                                line-height:16px;
                                color:#222C37;
                            }
                            span{
                                display:block;
                                padding-top:10px;
                                font-size:14px;
                                line-height:14px;
                                color:#7A8087;
                            }
                        }
                        .cover_op{
                            display:none;
                        }
                        &:hover{
                            .cover_op{
                                display:block;
                                position:absolute;
                                left:0;
                                top:0;
                                width:100%;
                                height:100%;
                                background: rgba(0, 196, 161, 0.5);
                                .op{
                                    position:absolute;
                                    right:10px;
                                    top:10px;
                                    width: 30px;
                                    height: 30px;
                                    background: #fff;
                                    border: 1px solid #F2F3F3;
                                    cursor:pointer;
                                    text-align:center;
                                    font-size:15px;
                                    color:#7A8087;
                                    line-height:28px;
                                    &:hover{
                                        background: #DEE0E1;
                                        &.del{
                                            &::after{
                                                @include btn-after('删除')
                                            }
                                        }
                                        &.replace{
                                            &::after{
                                                @include btn-after('替换')
                                            }
                                        }
                                    }
                                    &.replace{
                                        right:50px;
                                        box-sizing:border-box;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .disTxt{
                color:#FF4A4A;
                font-size:14px;
                line-height:14px;
                padding-top:10px;
            }
            .normal_tips{
                color:#7A8087;
                font-size:14px;
                line-height:14px;
                padding-top:14px;
            }
            ::v-deep .el-select{
                width:100%;
            }
            ::v-deep .el-radio-group{
                width: 100%;
                justify-content: space-between;
                .el-radio{
                    width: calc(50% - 10px);
                    margin: 0;
                }
            }
            .input{
                @include input-border();
                ::v-deep .el-input__inner{
                    font-size: 16px;
                    color: #223318;
                }
                ::v-deep .el-input__count{
                    color: #7a8087;
                    font-size: 16px;
                }
                select{
                    width: 100%;
                    height: 100%;
                    border: 1px solid #DEE0E1;
                    box-sizing: border-box;
                    padding: 0 10px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    filter: alpha(opacity = 0);
                    font-size: 16px;
                    appearance: none;
                    cursor: pointer;
                    z-index: 1;
                    background: transparent;
                }
                .icon_down{
                    position: absolute;
                    top: 50%;
                    right: 11px;
                    transform: translateY(-50%);
                    color: #7a8087;
                    pointer-events: none;
                }
                &.hour{
                    border: 1px solid #E8E8E8;
                    border-radius: 4px;
                    box-sizing: border-box;
                    ::v-deep(.el-date-editor){
                        width: 100%;
                        height: 100%;
                        display: block;
                        .el-input__wrapper{
                            cursor: pointer;
                            width: 100%;
                            height: 100%;
                            padding: 0;
                            box-shadow: none;
                            border-radius: 4px;
                        }
                        .el-input__inner{
                            cursor: pointer;
                            border: 0;
                            padding: 0 10px !important;
                            line-height: 36px;
                            font-size: 16px;
                            height: 100%;
                            display: block;
                        }
                        .el-input__prefix,.el-input__suffix{
                            display: none;
                        }
                    }
                }
            }
            .auth_bottom{
                display: flex;
                align-items: center;
                justify-content: end;
                >p{
                    margin: 0 20px 0 0;
                    a{
                        outline: none;
                        color: #425eb2;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
.jzb_tips{
    cursor: pointer;
    color: #222c37;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    i{
        color:#222C37;
        padding-right:3px;
        &.icon-select{
            color:#00C4A1;
        }
    }
    a{
        font-size: 14px;
        line-height: 1;
        color: #425EB2;
        cursor: pointer;
        text-decoration: underline;
        outline: none;
        font-weight:normal;
    }
}
</style>
<template>
    <div class="home" v-loading.fullscreen.lock="state.loading" element-loading-text="加载中...">
        <idea-header :stepIndex="state.stepIndex" @confirm="confirm" />
        <div class="main">
            <step-header :arr_step="state.arr_step" :stepIndex="state.stepIndex" @stepChange="stepChange"/>
            <div class="subTitle">基础信息</div>
            <div class="column">
                <div class="column_fix">
                    <div class="left">
                        <strong><span>*</span> 项目封面图</strong>
                        <p>格式 jpg、jpeg、png，分辨率 72 像素／英寸，不大于 1MB。</p>
                        <p class="bottom">
                            图片应简洁、清晰展示主题，内容所用字体须确保已取得相关字库授权。
                            <a class="outside-link" href="https://zhongchou.modian.com/helpcenter/qcategory?cid=6&amp;qid=55" target="_blank">推荐案例</a>
                        </p>
                    </div>
                    <div class="right">
                        <div class="cover_fix">
                            <div @click.stop="pushLogo('logo')">
                                <div class="cover_txt">
                                    <div class="upTips">
                                        <div class="logo"><i class="iconfont icon-pic"></i></div>
                                        <p>+ 上传图片（桌面端）</p>
                                        <span>尺寸 1080px*1080px</span>
                                    </div>
                                    <div v-if="ruleForm.logo" class="bg">
                                        <el-image style="width: 100%; height: 100%" :src="ruleForm.logo" fit="contain" />
                                    </div>
                                    <div v-if="ruleForm.logo" class="cover_op">
                                        <label class="op replace" @click.stop="pushLogo('logo')"><i class="iconfont icon-refresh"></i></label>
                                        <div class="op del" @click.stop="ruleForm.logo = ''"><i class="iconfont icon-trash"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div @click.stop="pushLogo('logo2')">
                                <div class="cover_txt recommend">
                                    <div class="upTips">
                                        <div class="logo"><i class="iconfont icon-pic"></i></div>
                                        <p>+ 上传图片（移动端）</p>
                                        <span>尺寸 1080px*462px</span>
                                    </div>
                                    <div v-if="ruleForm.logo2" class="bg">
                                        <el-image style="width: 100%; height: 100%" :src="ruleForm.logo2" fit="contain" />
                                    </div>
                                    <div v-if="ruleForm.logo2" class="cover_op">
                                        <label class="op replace" @click.stop="pushLogo('logo2')"><i class="iconfont icon-refresh"></i></label>
                                        <div class="op del" @click.stop="ruleForm.logo2 = ''"><i class="iconfont icon-trash"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="column_fix">
                    <div class="left">
                        <strong><span>*</span> 项目标题</strong>
                        <p>写一个清晰、意赅的标题，帮助人们快速理解你的项目主题。</p>
                    </div>
                    <div class="right">
                        <div class="input">
                            <el-input
                                v-model="ruleForm.name"
                                maxlength="26"
                                size="large"
                                placeholder="请输入项目标题，最多26个字"
                                show-word-limit
                                type="text"
                            />
                        </div>
                        <p v-if="titleDis" class="disTxt">未填写项目标题</p>
                        <p class="normal_tips">项目标题中禁止使用英文符号 & " '</p>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="column_fix">
                    <div class="left">
                        <strong><span>*</span> 项目短标题</strong>
                    </div>
                    <div class="right">
                        <div class="input">
                            <el-input
                                v-model="ruleForm.short_title"
                                maxlength="10"
                                size="large"
                                placeholder="请输入项目短标题，最多10个字"
                                show-word-limit
                                type="text"
                            />
                        </div>
                        <p v-if="titleDis" class="disTxt">未填写项目标题</p>
                        <p class="normal_tips">项目短标题中禁止使用英文符号 & " '</p>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="column_fix">
                    <div class="left">
                        <strong>项目类别</strong>
                    </div>
                    <div class="right">
                        <div class="input">
                            <el-select v-model="state.category" placeholder="请选择项目类别" size="large" :disabled="cateDisabled">
                                <el-option label="动物救助" value="动物救助" />
                                <el-option label="个人愿望" value="个人愿望" />
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="column_fix">
                    <div class="left">
                        <strong>期望上线时间</strong>
                    </div>
                    <div class="right">
                        <div class="input hour">
                            <el-date-picker
                                :editable="false"
                                v-model="ruleForm.start_time"
                                type="datetime"
                                placeholder="期望上线时间"
                                format="YYYY-MM-DD HH:mm"
                                :disabled="editDisabled"
                            />
                            <span class="icon_down">
                                <i class="iconfont icon-wait"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="column_fix">
                    <div class="left">
                        <strong>结束时间</strong>
                    </div>
                    <div class="right">
                        <div class="input hour">
                            <el-date-picker
                                :editable="false"
                                v-model="ruleForm.end_time"
                                type="datetime"
                                placeholder="结束时间"
                                format="YYYY-MM-DD HH:mm"
                                :disabled="editDisabled"
                            />
                            <span class="icon_down">
                                <i class="iconfont icon-wait"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="column_fix">
                    <div class="left">
                        <strong>目标金额</strong>
                    </div>
                    <div class="right">
                        <div class="input">
                            <el-input
                                v-model="ruleForm.goal"
                                size="large"
                                placeholder="2元起"
                                :disabled="editDisabled"
                                @input="mobileInput(ruleForm.goal)"
                                type="text"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="state.showJZB" class="column">
                <div class="column_fix">
                    <div class="left"></div>
                    <div class="right">
                        <p @click.stop="state.agreeJZB = !state.agreeJZB" class="jzb_tips">
                            <i v-if="state.agreeJZB" class="iconfont icon-select"></i>
                            <i v-else class="iconfont icon-unselected"></i>
                            已阅读并同意<a href="https://br.pingan.com/ttest" target="_blank">《平安银行“平安结算通”商户服务协议》</a>和<a href="https://auth.orangebank.com.cn/#/m/cDealOne?showNavBar=1" target="_blank">《平安数字用户服务协议》</a>平安银行将为您提供银行账号认证等服务。
                        </p>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="column_fix">
                    <div class="left"></div>
                    <div class="right">
                        <div class="auth_bottom">
                            <p>查看<a class="outside-link" :href="agreementUrl" target="_blank">《众筹协议》</a></p>
                            <el-button type="primary" @click.stop="submitForm">{{if_show == 1 ? '保存' : '提交'}}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Uploader ref="uploaderChild" :accept="state.UploaderAccept" :isCrop="true" :fixedNumber="[1,1]" :autoCropWidth="1080" :autoCropHeight="1080" :minWidth="0" @onBeforeUpload="state.loading = true" @onError="state.loading = false" @onSuccess="handleSuccess" />
    <Uploader ref="uploaderChildLogo2" :accept="state.UploaderAccept" :isCrop="true" :fixedNumber="[7,3]" :autoCropWidth="1080" :autoCropHeight="462" :minWidth="0" @onBeforeUpload="state.loading = true" @onError="state.loading = false" @onSuccess="handleSuccess" />
</template>
<script setup>
import { ref, reactive, computed, onBeforeMount, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import domain from '@/service/domain'
import tools from '@/utils/tools.js'
import ideaHeader from "@/components/initiate/idea/header";
import stepHeader from "@/components/initiate/idea/step";
import { getBase, editBase, Create, getProjectActions, getProjectInfo, checkRewardTimeline, getUserAuthStatus } from '@/api/index'
const route = useRoute()
const router = useRouter()
const store = useStore();
const pro_id = computed(() =>
    store.getters.pro_id || route.query.id
)
const pro_class = computed(() =>
    store.getters.pro_class || route.query.pro_class
)
const category = computed(() =>
    route.query.category || store.getters.category
)
const cateDisabled = computed(() =>
    store.getters.pro_id ? true : false
)
const editDisabled = computed(() =>
    store.getters.disabled
)
const if_show = computed(() =>
    store.getters.if_show
)
const domain_zhongchou = domain.zhongchou;
const ruleForm = reactive({
    logo:'',
    logo2:'',
    name: '',
    short_title: '',
    start_time: '',
    end_time: '',
    des: '',
    goal:''
})
const state = reactive({
    category:'',
    loading:false,
    submitTxt: if_show.value == 1 ? '保存' : '提交',
    UploaderAccept:'image/jpg,image/jpeg,image/png',
    stepIndex:0,
    arr_step:[
        {
            icon:"step1",
            txt:'基础信息',
            name:'initiate_base',
        },
        {
            icon:"step4",
            txt:'详情编辑',
            name:'initiate_detail',
        },
        {
            icon:"step3",
            txt:'设置商品',
            name:'initiate_reward',
        },
    ],
    logoType:'logo',
    showJZB:false, // 显示见证宝协议
    agreeJZB:true, // 同意见证宝协议
    editDisabled:false
})
if(category.value){
    state.category = category.value;
}
const agreementUrl = computed(() =>
    store.getters.category == '动物救助' ? 'https://zhongchou.modian.com/about/index/3/11.html' : 'https://zhongchou.modian.com/about/index/3/6.html'
)
// 提交callback
const submitCallBack = () => {
    state.loading = true;
    let option = {
        province: '',
        city: '',
        pro_type: '',
        pro_class: pro_class.value,
        category: state.category,
        protocol_confirm_time:Date.parse(new Date()).toString().substr(0,10),
        wb_logo_1:ruleForm.logo,
        logo2:ruleForm.logo2,
        name: ruleForm.name,
        short_title:ruleForm.short_title,
        start_time: ruleForm.start_time,
        end_time: ruleForm.end_time,
        des: ruleForm.des,
        goal:ruleForm.goal
    }
    if(pro_id.value){
        checkRewardTimeline(
            {
                pro_id: pro_id.value,
                start_time: ruleForm.start_time,
                end_time: ruleForm.end_time,
            }
        ).then(res => {
            if(res.status == 1 || res.status == 0){
                option.pro_id = pro_id.value;
                option.pro_class = pro_class.value;
                editBase({os_data:JSON.stringify(option),pro_id: pro_id.value,pro_class: pro_class.value}).then(res => {
                    state.loading = false;
                    if(res.status == 1 || res.status == 0){
                        tools.confirm({
                            title:'提示',
                            msg:'保存成功'
                        },() => {
                            router.push({
                                name: 'initiate_detail',
                                query: {
                                    id:pro_id.value
                                }
                            })
                        });
                    }else{
                        tools.confirm(res.message);
                    }
                })
            }else{
                state.loading = false;
                tools.confirm(res.message);
            }
        })
    }else{
        Create({os_data:JSON.stringify(option),pro_class: pro_class.value}).then(res => {
            state.loading = false;
            if(res.status == 1 || res.status == 0){
                store.dispatch('setProId', res.data.next_step);
                tools.confirm({
                    title:'提示',
                    hasCancel:false,
                    success:'下一步',
                    msg:'项目创建成功'
                },() => {
                    router.push({
                        name: 'initiate_detail',
                        query: {
                            id:res.data.next_step
                        }
                    })
                });
            }else{
                tools.confirm(res.message);
            }
        })
    }
}
const submitForm = () => {
    if(!ruleForm.logo || !ruleForm.logo2){
        tools.confirm({
            title:'提示',
            success:'确定',
            msg:'请上传项目封面图。'
        },() => {
            document.documentElement.scrollTop = 0;
        });
        state.loading = false;
        return false;
    }
    if(!ruleForm.name){
        tools.toast('请填写项目标题');
        return false;
    }
    if(isFormat(ruleForm.short_title)){
        tools.toast('项目标题中禁止使用相关英文符号');
        return false;
    }
    if(!ruleForm.short_title){
        tools.toast('请填写项目短标题');
        return false;
    }
    if(isFormat(ruleForm.name)){
        tools.toast('项目短标题中禁止使用相关英文符号');
        return false;
    }
    if(!state.category){
        tools.confirm('请选择项目类别');
        state.loading = false;
        return false;
    }
    var startTime = +new Date(ruleForm.start_time),
        endTime = +new Date(ruleForm.end_time);
    if (startTime > endTime){
        tools.confirm('开始时间不能晚于结束时间');
        state.loading = false;
        return false;
    }
    if (endTime - startTime < 1 *  60 * 60 * 1000) {
        tools.confirm('众筹至少为一小时');
        state.loading = false;
        return false;
    } else if (endTime - startTime > 60 * 24 * 60 * 60 * 1000) {
        tools.confirm('众筹至多为60天');
        state.loading = false;
        return false;
    }
    // if(state.showJZB){
    //     if(!state.agreeJZB){
    //         tools.confirm('请阅读并同意相关协议');
    //         state.loading = false;
    //         return false;
    //     }
    //     let option = {
    //         macAddress:'00-00-00-00-00-00',
    //         signChannel:'PC'
    //     }
    //     addRegisterRecordInfo(option).then(res => {
    //         console.log(res)
    //     });
    // }
    submitCallBack();
}
// 替换
const uploaderChild = ref(null);
const uploaderChildLogo2 = ref(null)
// 单图
const handleSuccess = (item) => {
    state.logoType == 'logo' ? ruleForm.logo = item : ruleForm.logo2 = item;
    state.loading = false;
}
const pushLogo = type => {
    state.logoType = type;
    if(type == 'logo'){
        uploaderChild.value.onClick();
    }else{
        uploaderChildLogo2.value.onClick();
    }
}
const getAuthInfo = async () => {
    const { status, data } = await getUserAuthStatus();
    if(status == 0){
        if(Number(data.auth_cate) == 11){
            if(data.person_auth_info && Number(data.person_auth_info.age) < 18){
                tools.confirm({
                    title:'提示',
                    hasCancel:false,
                    success:'好的',
                    showClose:false,
                    msg:'您还未满18周岁不能发起项目',
                },() => {
                    window.location.href = `${domain.www}/user/center`
                });
                return false;
            }
            if(data.person_auth_info && !data.person_auth_info.id_card_effective){
                tools.confirm({
                    title:'提示',
                    hasCancel:false,
                    success:'去认证',
                    showClose:false,
                    msg:'证件已过期，请重新认证再发起',
                },() => {
                    let auth_url = domain_zhongchou+'/auth/auth_person';
                    window.location.href = auth_url;
                });
                return false;
            }
        }
    }
}
onBeforeMount(async () => {
    getAuthInfo();
    if(pro_id.value){
        store.dispatch('setProId', pro_id.value);
        getProjectActions({pro_id:pro_id.value}).then(res => {
            if(res.status == 0) {
                store.dispatch('setProInfo', res.data.project);
                getProjectInfo({pro_id:pro_id.value,temp_id: 0}).then(res => {
                    if(res.status == 0) {
                        store.dispatch('setCategory', res.data.category);
                        store.dispatch('setProClass', res.data.pro_class);
                        store.dispatch('setIfShow', res.data.if_show);
                        localStorage.setItem('initiate_pro_class',res.data.pro_class);
                        if(Number(res.data.if_show) == 1){
                            store.dispatch('setDisabled', true);
                        }
                        store.dispatch('setInitDone', true);
                        getBase({id:pro_id.value}).then(res => {
                            if(res.status == 0 && res.data){
                                ruleForm.logo = res.data.wb_logo_1;
                                ruleForm.logo2 = res.data.logo2;
                                ruleForm.name = res.data.name;
                                ruleForm.short_title = res.data.short_title;
                                state.category = res.data.category;
                                store.dispatch('setCategory', res.data.category);
                                store.dispatch('setProClass', res.data.pro_class);
                                ruleForm.start_time = res.data.start_time;
                                ruleForm.end_time = res.data.end_time;
                                ruleForm.des = res.data.des;
                                ruleForm.goal = res.data.goal;
                            }else{
                                tools.confirm(res.message);
                            }
                        })
                    }
                }).catch(error => {
                    console.error(error);
                })
            }else{
                store.dispatch('setDisabled', true);
                tools.confirm({
                    title:'提示',
                    hasCancel:false,
                    success:'返回',
                    msg:res.message
                },() => {
                    location.href = domain_zhongchou+'/project_new/pro_cover?id='+pro_id.value
                });
            }
        }).catch(error => {
            console.error(error);
        })
    }else{
        let sTime = tools.dateFormat(+new Date() + 0);
        let eTime = tools.dateFormat(+new Date() + 1* 24 * 60 * 60 * 1000);
        let defSTime = sTime[0] + '-' + sTime[1] + '-' + sTime[2] + ' 19:00';
        let defETime = eTime[0] + '-' + eTime[1] + '-' + eTime[2] + ' 19:00';
        ruleForm.start_time = defSTime;
        ruleForm.end_time = defETime;
    }
});
onMounted(() => {
    // checkRegisterRecordInfo({}).then(res => {
    //     if(res.status == 0 && res.data){
    //         if(Number(res.data.status) == 1){
    //             state.showJZB = true;
    //         }
    //     }
    // })
})
onUnmounted(() => {
    
})
// 顶部步骤条切换
const stepChange = index => {
    state.stepIndex = index;
    router.push({
        name: state.arr_step[index].name,
        query: {
            id:pro_id.value
        }
    })
}
const mobileInput = (data) => {
    data = floatLimit(data);
    ruleForm.goal = data;
}
const floatLimit = (val) => {
    val = val.replace(/[^\d.]/g, "");
    while(val.indexOf(0) == 0){
        val = val.replace(/[^\d]|^[0]/g, "");
        console.log(val);
    }
    return val
}
function isFormat(str){
    return /([&"'])/g.test(str);
}
</script>